<template lang="pug">
.container.grid-xl
  page-title(icon="fas fa-cogs" title="Parâmetros" subtitle="Parâmetros gerais do sistema podem ser configurados aqui")
  .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
  fieldset(v-else :disabled="loading")
    form(@submit.prevent="onSubmit")
      .columns
        .column.col-6.col-lg-7.col-md-8.col-sm-12
          .columns
            .column.col-12.divider.text-center(data-content="Elasticsearch")
            .column.col-12
              form-group(label="URL ou CloudID do Elasticsearch" :validation="$v.systemParametersModel" field="elasticsearchHost")
                input.form-input(v-model="$v.systemParametersModel.elasticsearchHost.$model")
            .column.col-6.col-sm-12
              form-group(label="Usuário do Elasticsearch" :validation="$v.systemParametersModel" field="elasticsearchUsername")
                input.form-input(v-model="$v.systemParametersModel.elasticsearchUsername.$model")
            .column.col-6.col-sm-12
              form-group(label="Senha do Elasticsearch" :validation="$v.systemParametersModel" field="elasticsearchPassword")
                input.form-input(type="password" v-model="$v.systemParametersModel.elasticsearchPassword.$model")
            .column.col-12.divider.text-center(data-content="Gateway de pagamento")
            .column.col-12
              form-group(label="Gateway de pagamento padrão" :validation="$v.systemParametersModel" field="defaultPaymentGateway")
                select.form-select(v-model="$v.systemParametersModel.defaultPaymentGateway.$model")
                  option(v-for="(paymentGateway, key) in paymentGateways" :value="key") {{paymentGateway}} 
            .column.col-12.divider.text-center(data-content="Iugu")
            .column.col-12
              form-group(label="ID da conta" :validation="$v.systemParametersModel" field="iuguPaymentGatewayAccountId")
                input.form-input(v-model.trim="$v.systemParametersModel.iuguPaymentGatewayAccountId.$model")
            .column.col-12.divider.text-center(data-content="Vindi")
            .column.col-12
              form-group(label="ID do produto de item de compra" :validation="$v.systemParametersModel" field="vindiPurchaseExternalProductItemId")
                input.form-input(v-model.trim="$v.systemParametersModel.vindiPurchaseExternalProductItemId.$model")
            .column.col-12.divider.text-center(data-content="Vimeo")
            .column.col-6.col-sm-12
              form-group(label="URL" :validation="$v.systemParametersModel" field="vimeoBaseUrl")
                input.form-input(v-model.trim="$v.systemParametersModel.vimeoBaseUrl.$model")
            .column.col-6.col-sm-12
              form-group(label="Client ID" :validation="$v.systemParametersModel" field="vimeoClientId")
                input.form-input(v-model.trim="$v.systemParametersModel.vimeoClientId.$model")
            .column.col-12
              form-group(label="Client Secret" :validation="$v.systemParametersModel" field="vimeoClientSecret")
                input.form-input(v-model.trim="$v.systemParametersModel.vimeoClientSecret.$model")
            .column.col-12
              form-group(label="Token de acesso" :validation="$v.systemParametersModel" field="vimeoAccessToken")
                input.form-input(v-model.trim="$v.systemParametersModel.vimeoAccessToken.$model")
            .column.col-12.divider.text-center(data-content="Percentual de ganho dos parceiros")
            .column.col-6.col-sm-12
              form-group(
                label="Assinatura"
                :validation="$v.systemParametersModel"
                field="filiationSubscriptionPercentage"
                help="As assinaturas feitas a partir do link do afiliado renderão este percentual a ele"
              )
                masked-money.form-input(v-model="$v.systemParametersModel.filiationSubscriptionPercentage.$model" v-bind="valueAttrs")
            .column.col-6.col-sm-12
              form-group(
                label="Venda"
                :validation="$v.systemParametersModel"
                field="filiationPurchasePercentage"
                help="As compras feitas a partir do link do afiliado renderão este percentual a ele"
              )
                masked-money.form-input(v-model="$v.systemParametersModel.filiationPurchasePercentage.$model" v-bind="valueAttrs")
            .column.col-12.divider.text-center(data-content="Percentual de ganho dos produtores de conteúdo")
            .column.col-6.col-sm-12
              form-group(
                label="Assinatura"
                :validation="$v.systemParametersModel"
                field="contentProducerSubscriptionPercentage"
                help="As assinaturas feitas a partir do link do afiliado quando ele for produtor de conteúdo renderão este percentual a ele"
              )
                masked-money.form-input(v-model="$v.systemParametersModel.contentProducerSubscriptionPercentage.$model" v-bind="valueAttrs")
            .column.col-6.col-sm-12
              form-group(
                label="Venda"
                :validation="$v.systemParametersModel"
                field="contentProducerPurchasePercentage"
                help="As compras feitas a partir do link do afiliado quando ele for produtor de conteúdo renderão este percentual a ele"
              )
                masked-money.form-input(v-model="$v.systemParametersModel.contentProducerPurchasePercentage.$model" v-bind="valueAttrs")
            .column.col-12
              form-group(
                label="Percentual direcionado aos produtores de conteúdo"
                :validation="$v.systemParametersModel"
                field="totalFiliationVideoWatchMonetizationPercent"
                help="Este percentual será direcionado para os produtores de conteúdo, será retirado das compras e assinaturas de planos e produtos que estejam com a opção de monetização ativa"
              )
                masked-money.form-input(v-model="$v.systemParametersModel.totalFiliationVideoWatchMonetizationPercent.$model" v-bind="valueAttrs")
            .column.col-12.divider.text-center(data-content="Compras")
            .column.col-6.col-sm-12
              form-group(
                label="Dias para cancelamento"
                :validation="$v.systemParametersModel"
                field="maxDaysToRefundPurchase"
                help="É o prazo que o usuário tem em dias para poder cancelar uma compra"
              )
                input.form-input(type="number" v-model.number="$v.systemParametersModel.maxDaysToRefundPurchase.$model")
            .column.col-6.col-sm-12
              form-group(
                label="Desconto em compras de assinante"
                :validation="$v.systemParametersModel"
                field="subscriberPurchaseDiscountPercent"
                help="Percentual de desconto que os assinantes terão ao realizar uma compra"
              )
                masked-money.form-input(v-model="$v.systemParametersModel.subscriberPurchaseDiscountPercent.$model" v-bind="valueAttrs")
            .divider.col-12
            .column.col-12.text-right
              button.btn.btn-primary(:disabled="disabled") Salvar
</template>

<script>
import { required, url } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import { deepClone } from 'paliari-js-utils'
import { paymentGateways } from '@/lib/constants'
import minValue from 'vuelidate/lib/validators/minValue'
import maxValue from 'vuelidate/lib/validators/maxValue'

export default {
  data() {
    return {
      loading: false,
      error: null,
      paymentGateways,
      systemParametersModel: {
        vindiPurchaseExternalProductItemId: '',
        vimeoBaseUrl: '',
        vimeoClientId: '',
        vimeoClientSecret: '',
        vimeoAccessToken: '',
        filiationPurchasePercentage: 0,
        filiationSubscriptionPercentage: 0,
        contentProducerPurchasePercentage: 0,
        contentProducerSubscriptionPercentage: 0,
        subscriberPurchaseDiscountPercent: 0,
        defaultPaymentGateway: paymentGateways.iugu,
        iuguPaymentGatewayAccountId: '',
        totalFiliationVideoWatchMonetizationPercent: 0,
        maxDaysToRefundPurchase: 0,
      },
    }
  },

  computed: {
    ...mapState('systemParameters', ['systemParameters']),

    disabled() {
      return this.loading || this.$v.$invalid
    },

    valueAttrs() {
      return { suffix: ' %' }
    },
  },

  async created() {
    try {
      this.loading = true
      if (!this.systemParameters) {
        await this.fetchSystemParameters()
      }

      if (this.systemParameters) {
        this.systemParametersModel = deepClone(this.systemParameters)
      }
    } catch (e) {
      this.error = e
    } finally {
      this.loading = false
    }
  },

  methods: {
    ...mapActions('systemParameters', [
      'fetchSystemParameters',
      'createOrUpdateSystemParameters',
    ]),

    async onSubmit() {
      try {
        this.loading = true
        await this.createOrUpdateSystemParameters(this.systemParametersModel)
        this.systemParametersModel = deepClone(this.systemParameters)
        this.$toaster.success('Parâmetros criados/atualizados com sucesso')
      } catch (e) {
        this.$toaster.error('Erro ao criar/atualizar parâmetros')
      } finally {
        this.loading = false
      }
    },
  },

  validations: {
    systemParametersModel: {
      elasticsearchHost: {
        required,
      },
      elasticsearchUsername: {},
      elasticsearchPassword: {},
      filiationPurchasePercentage: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(10000),
      },
      filiationSubscriptionPercentage: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(10000),
      },
      subscriberPurchaseDiscountPercent: {
        minValue: minValue(0),
        maxValue: maxValue(10000),
      },
      contentProducerPurchasePercentage: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(10000),
      },
      contentProducerSubscriptionPercentage: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(10000),
      },
      vindiPurchaseExternalProductItemId: { required },
      vimeoBaseUrl: { required, url },
      vimeoClientId: { required },
      vimeoClientSecret: { required },
      vimeoAccessToken: { required },
      defaultPaymentGateway: { required },
      iuguPaymentGatewayAccountId: { required },
      totalFiliationVideoWatchMonetizationPercent: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(10000),
      },
      maxDaysToRefundPurchase: { required },
    },
  },
}
</script>
